import React from "react";
import { motion } from "framer-motion";
import { Settings } from "lucide-react";

const CARD_COLORS = [
  "from-yellow-300 to-amber-400",
  "from-sky-300 to-cyan-400",
  "from-pink-300 to-fuchsia-400",
  "from-lime-300 to-green-400",
  "from-orange-300 to-red-400",
  "from-purple-300 to-indigo-400",
];

export default function Card({ title, children, colorIndex = 0, onEdit }) {
  const gradient = CARD_COLORS[colorIndex % CARD_COLORS.length];
  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.25 }}
      className={`relative rounded-2xl lg:rounded-3xl p-3 lg:p-4 xl:p-6 shadow-lg bg-gradient-to-br ${gradient} text-slate-900 group h-full flex flex-col min-h-0 overflow-hidden`}
    >
      {onEdit && (
        <button
          onClick={onEdit}
          className="absolute top-2 lg:top-3 xl:top-4 right-2 lg:right-3 xl:right-4 p-2 lg:p-2.5 rounded-full bg-white/20 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-white/30 z-10"
          aria-label={`Edit ${title}`}
        >
          <Settings className="w-4 h-4 lg:w-5 lg:h-5 xl:w-6 xl:h-6" />
        </button>
      )}
      <div className="flex items-center justify-between mb-2 lg:mb-3 xl:mb-4 flex-shrink-0">
        <h2 className="text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-fredoka font-bold drop-shadow-sm">{title}</h2>
      </div>
      <div className="bg-white/75 rounded-xl lg:rounded-2xl p-3 lg:p-4 xl:p-6 shadow-inner flex-1 flex flex-col min-h-0 overflow-hidden">
        {children}
      </div>
    </motion.div>
  );
}
